import Box from '@mui/material/Box';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import axios from 'axios';
import {config} from '../../common/config/config';
import {
    constance,
    WorkplaceInterface,
} from '../../common/constance/constance';
import {common} from '../../common/common';
import {styles} from '../../common/style';
import {useNavigate} from 'react-router-dom';
import PostEditor from './editor/PostEditor';
import TextField from '@mui/material/TextField';
import {MenuInterface} from "../../interface/menu.interface";
import {
    CircularProgress,
    FormControl,
    FormControlLabel,
    MenuItem,
    MenuList,
    Paper,
    Radio,
    RadioGroup
} from "@mui/material";
import {Club} from "../../interface/club.interface";
import {Department} from "../../interface/department.interface";
import ReactQuill from "react-quill";
import SelectDepartmentComponent from "./selectOption/SelectDepartmentComponent";
import {initClub, initDepartment} from "../../common/initState";
import SelectClubComponent from "./selectOption/SelectClubComponent";
import FileUpload from "./fileUpload/FileUpload";
import {isMobile} from "react-device-detect";
import ShareBoardInputComponent from "./shareInputs/ShareBoardInputComponent";
import FleaMarketBoardInputComponent from "./shareInputs/FleaMarketBoardInputComponent";
import {FleaMarket} from "../../interface/fleaMarket.interface";


interface State {
    _id: string,
    contents: string,
    createdAt: Date | null,
    id: string,
    no: number,
    title: string,
    usage: string,
    workplace: string,
    amount: number,
    shareStatus: number,
    clubList: Club[],
    selectOptionOpen: boolean;
    departmentList: Department[],
    files: File[],
    fmCategory: string; //플리마켓 카테고리
    fmProductName: string;  //플리마켓 제품명
    fmBrand: string;  //플리마켓 브랜드
    fmModelNo: string; //플리마켓 모델번호
    fmPurchasePrice: number;  //플리마켓 구매가
    fmSellingPrice: number;   //플리마켓 판매가
    fleaMarket: FleaMarket;
}


export default function PostWrite() {
    const [state, setState] = useState<State>({
        _id: '',
        contents: '',
        createdAt: null,
        id: '',
        no: 0,
        title: '',
        usage: '',
        workplace: '0',
        amount: 1,
        shareStatus: 0,
        clubList: [],
        selectOptionOpen: false,
        departmentList: [],
        files: [],
        fmCategory: '',
        fmProductName: '',
        fmBrand: '',
        fmModelNo: '',
        fmPurchasePrice: 0,
        fmSellingPrice: 0,
        fleaMarket: {
            _id: "",
            createdAt: new Date(),
            end: new Date(),
            openYN: "",
            start: new Date(),
            title: "",
            usage: "",
            workplace: ""
        }
    });

    const [selectedClub, setSelectedClub] = useState<Club>(initClub);
    const [selectedDepartment, setSelectedDepartment] = useState<Department>(initDepartment);

    const loadingRef: any = useRef();

    const fmCategoryRef: any = useRef();
    const fmProductNameRef: any = useRef();
    const fmBrandRef: any = useRef();
    const fmModelNoRef: any = useRef();
    const fmPurchasePriceRef: any = useRef();
    const fmSellingPriceRef: any = useRef();


    const navigate = useNavigate();
    let {id, workplace, no, page, fmId} = common.getQuery();
    let menu: MenuInterface = useMemo(() => common.getMenuObject(id), [id]);
    const QuillRef: any = useRef<ReactQuill>();
    useEffect(() => {

        if (id == 'fleaMarket') {
            axios.get(constance.api.getFleaMarket, {params: {_id: fmId}}).then(value => {
                setState({
                    ...state,
                    fleaMarket: value.data.fleaMarket
                })
            })
        }
        // common.getMenuData(menu, setState, state);
    }, []);


    function handleSavePost() {
        let contents: any = QuillRef.current.value;
        if (state.title == '') {
            common.alert('제목을 입력해주세요.', '', 'info');
            return;
        } else if (contents == '') {
            common.alert('내용을 입력해주세요.', '', 'info');
            return;
        } else if (menu.id == config.clubId && selectedClub._id == '') {
            common.alert('동호회를 선택해주세요.', '', 'info');
            return;
        } else if (menu.id == 'bestFriends' && state.workplace == '0') {
            common.alert('사업장을 선택해주세요.', '', 'info');
            return;
        } else {
            if (id == 'share') {
                let matchResult: any = contents.match(/(<img[^>]+src\s*=\s*[\"']?([^>\"']+)[\"']?[^>]*>)/i);
                if (matchResult == null) {
                    common.alert('나눔할 물건 이미지를 넣어주세요.', '', 'info');
                    return;
                }
            } else if (id == 'fleaMarket') {
                if (!fmId) {
                    common.alert('잘못된 접근입니다.', '', 'info');
                    return;
                }

                let matchResult: any = contents.match(/(<img[^>]+src\s*=\s*[\"']?([^>\"']+)[\"']?[^>]*>)/i);
                if (matchResult == null) {
                    common.alert('판매할 물건 이미지를 1개 이상 넣어주세요.', '', 'info');
                    return;
                }
            }
        }


        loadingRef.current.style.display = 'flex';


        const formData = new FormData();
        for (let file of state.files) {
            const encodedFileName = encodeURIComponent(file.name);
            formData.append('files', file, encodedFileName);
        }

        let values: any = {
            id: id,
            workplace: state.workplace,
            contents: contents,
            title: state.title,
            amount: state.amount,
            shareStatus: state.shareStatus,
            club: selectedClub._id,
            department: selectedDepartment._id,
        }

        if (id === 'fleaMarket') {
            // values.fmCategory = fmCategoryRef.current.value;
            values.fmProductName = fmProductNameRef.current.value;
            values.fmBrand = fmBrandRef.current.value;
            values.fmModelNo = fmModelNoRef.current.value;
            values.fmPurchasePrice = fmPurchasePriceRef.current.value;
            values.fmSellingPrice = fmSellingPriceRef.current.value;
            values.fmId = fmId;
        }

        formData.append('values', JSON.stringify(values));

        axios({
            method: 'post',
            url: constance.api.createPost,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then(value => {
            if (value.data.success) {
                common.alert('게시글 등록 완료', '', 'info');
                navigate(`${config.url.postView}?id=${id}&workplace=${state.workplace}&no=${value.data.post.no}`);
            } else {
                common.alert('게시글 등록 실패', '', 'error');
            }
            console.log(value);
        }).catch(reason => {
            console.log(reason);
        }).finally(() => {
            loadingRef.current.style.display = 'none';
        });

        /*
                axios.post(constance.api.createPost, {
                    id: id,
                    workplace: state.workplace,
                    contents: contents,
                    title: state.title,
                    amount: state.amount,
                    shareStatus: state.shareStatus,
                    club: selectedClub._id,
                    department: selectedDepartment._id,
                })*/
    }

    function handleChangeTitle(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
        setState({
            ...state,
            title: e.target.value,
        });
    }

    function handleChangeWorkplace(workplace: number) {
        setSelectedClub({
            ...initClub,
        });
        setSelectedDepartment({
            ...initDepartment
        })
        setState({
            ...state,
            workplace: workplace.toString(),
        })
    }


    // 나눔 게시판 전용... 수량
    function changeAmount(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
        let value = Number(e.target.value);
        if (value < 1) return;
        setState({
            ...state,
            amount: value
        })
    }

    function handleSelectOptionOpen(isOpen: boolean) {
        console.log('handleSelectOptionOpen', isOpen, selectedClub);
        setState({
            ...state,
            selectOptionOpen: isOpen
        })
    }

    function selectClub(e: React.MouseEvent<HTMLLIElement>, club: Club) {
        setSelectedClub(club);
        setState({
            ...state,
            workplace: club.workplace,
            selectOptionOpen: false
        })
    }

    function selectDepartment(e: React.MouseEvent<HTMLLIElement>, department: Department) {
        setSelectedDepartment(department);
        setState({
            ...state,
            workplace: department.workplace,
            selectOptionOpen: false
        })
    }

    return (
        <>

            <Box ref={loadingRef} sx={{
                width: '100vw', height: '100vh', position: 'fixed',
                display: 'none',
                justifyContent: 'center',
                alignItems: 'center',
                background: '#00000033',
                zIndex: 100000,
            }}>
                <CircularProgress/>
            </Box>

            <Box sx={{display: 'flex', justifyContent: 'center', p: 1}}>
                <Stack sx={{
                    width: 1,
                    maxWidth: config.maxWidth,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', mb: 2,
                }}>
                    {/* 사업장 선택이 있는 게시판일 경우 => 사업장 선택 버튼 생성 */}
                    <Box sx={{
                        width: 1,
                        display: config.editorWorkplaceBoardList.includes(menu.id) ? 'flex' : 'none',
                        justifyContent: 'flex-start', alignItems: 'center',
                        mt: 1,
                        mb: 1,
                        border: styles.border,
                        backgroundColor: 'var(--scc-surface)', borderRadius: 1,
                    }}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: 1,
                            p: 2,
                            width: 100,
                            minWidth: 100,
                            backgroundColor: '#696969'
                        }}>
                            <Typography sx={{color: 'white'}}> 사업장 선택 </Typography>
                        </Box>
                        <Divider orientation={'vertical'} sx={{mr: 2}}/>
                        <Box sx={{display: 'flex', flexWrap: 'wrap', pt: 1, pb: 1}}>
                            {
                                Object.keys(constance.workplace).map((key, index) => {
                                    // if ((menu.id == config.clubId || menu.id == config.departmentId) && key == 'ALL') {
                                    //     return
                                    // }
                                    if (menu.id !== 'notice' && menu.id !== 'event' && key === 'ALL') {
                                        return
                                    }
                                    const workplaceObject: any = constance.workplace;
                                    const _workplace: WorkplaceInterface = workplaceObject[key];
                                    return (
                                        <Button
                                            variant={state.workplace == _workplace.value.toString() ? 'contained' : 'outlined'}
                                            color={'neutral'}
                                            key={index}
                                            onClick={() => handleChangeWorkplace(_workplace.value)}
                                            sx={{
                                                m: 0.5,
                                                background: state.workplace == _workplace.value.toString() ? '#444444' : 'var(--scc-surface)'
                                            }}>
                                            {_workplace.name}
                                        </Button>
                                    );
                                })
                            }
                        </Box>
                    </Box>


                    {/* 나눔 게시판 전용*/}
                    {
                        menu.id === 'share' ?
                            <ShareBoardInputComponent menu={menu}
                                                      state={state}
                                                      changeShareStatus={() => {
                                                      }}
                                                      changeAmount={changeAmount}
                            /> : ''
                    }

                    {/* 플리마켓 게시판 전용 */}
                    {
                        menu.id === 'fleaMarket' ?
                            <FleaMarketBoardInputComponent menu={menu}
                                                           state={state}
                                                           setState={setState}
                                                           refs={{
                                                               fmCategoryRef: fmCategoryRef,
                                                               fmProductNameRef: fmProductNameRef,
                                                               fmBrandRef: fmBrandRef,
                                                               fmModelNoRef: fmModelNoRef,
                                                               fmPurchasePriceRef: fmPurchasePriceRef,
                                                               fmSellingPriceRef: fmSellingPriceRef,
                                                           }}
                                                           changeShareStatus={() => {
                                                           }}
                                                           changeAmount={changeAmount}
                                                           isUpdatePage={false}
                            /> : ''
                    }


                    {/* 동호회 게시판 전용 Input */}
                    {
                        config.clubId === menu.id ?
                            <SelectClubComponent state={selectedClub}
                                                 setState={setSelectedClub}
                                                 workplace={state.workplace}/> : ''
                    }


                    {/* 부서 게시판 전용 Input */}
                    {
                        config.departmentId === menu.id ?
                            <SelectDepartmentComponent state={selectedDepartment}
                                                       setState={setSelectedDepartment}
                                                       workplace={state.workplace}/> : ''
                    }


                    {/* 제목 */}
                    <Box sx={{
                        width: 1,
                        display: 'flex',
                        backgroundColor: 'var(--scc-surface)',
                        borderRadius: 1
                    }}>
                        <TextField placeholder={menu.placeholder == '' ? '제목을 입력해주세요' : menu.placeholder}
                                   label="" variant="outlined"
                                   onChange={(e) => handleChangeTitle(e)}
                                   style={{border: 'none'}}
                                   sx={{width: 1, backgroundColor: 'var(--scc-surface)'}}
                        />
                    </Box>

                    {/* 에디터 */}
                    <Stack sx={{
                        width: 1,
                        position: 'relative',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        mt: 1,
                        background: 'var(--scc-surface)',
                        minHeight: 400,
                        '.ql-container': {
                            height: isMobile ? 'calc(100% - 68px)' : 'calc(100% - 41px)',
                        },
                        '.ql-editor': {
                            maxHeight: '600px'
                        }
                    }}>
                        {/* 에디터 */}
                        <PostEditor readOnly={false} QuillRef={QuillRef} initContent={''}/>
                    </Stack>
                    {/* 파일 업로드 */}
                    <FileUpload state={state} setState={setState}/>


                    {/* 등록 */}
                    <Box sx={{width: 1, mt: 2, display: 'flex', justifyContent: 'flex-end'}}>
                        <Button variant={'contained'}
                                color={'primary'}
                                onClick={handleSavePost}
                        >
                            <Typography>등록</Typography>
                        </Button>
                    </Box>
                </Stack>
            </Box>
        </>
    );
}
